<template>
  <div
    class="board"
    @click.stop=""
  >
    <div>
      <h2 class="board-title">
        {{ departure.alias }} {{ departure.preview ? '' : departure.name }}
      </h2>
      <div class="tabs">
        <a
          href="#"
          class="tab"
          @click.prevent="tab = null"
          :class="{ active: $route.params.tab == null }"
        >
          DETALLE
        </a>
        <a
          href="#"
          class="tab"
          title="PROXIMAMENTE"
          @click.prevent="tab = 'reservar'"
          :class="{ active: $route.params.tab == 'reservar' }"
          v-if="
            !departure.preview && departure.rates.some(rate => rate.availability != 2)
          "
        >
          RESERVAR
        </a>
        <a
          href="#"
          class="tab"
          @click.prevent="tab = 'seguro'"
          :class="{ active: $route.params.tab == 'seguro' }"
          v-if="departure.insurance"
        >
          COBERTURA MEDICA
        </a>
      </div>
    </div>
    <div class="board-content pt-3">
      <transition
        name="sld"
        mode="out-in"
      >
        <component
          :is="tab"
          :departure="departure"
          @close="close"
        />
      </transition>
    </div>
  </div>
</template>

<script>
/* eslint no-unreachable: "off" */

import Detail from './Detail'
import TravelAce from './TravelAce'
import Modal from '@/components/Modal'

import Init from '../booking/Init'
import Rates from '../booking/Rates'
import Rooming from '../booking/Rooming'
import Conditions from '../booking/Conditions'
import Success from '../booking/Success'

export default {
  components: {
    Modal,
    Detail,
    TravelAce,
    Rooming,
    Init,
    Rates,
    Conditions,
    Success
  },

  computed: {
    tab: {
      get () {
        switch (this.$route.params.tab) {
          case 'reservar':
            return this.$store.state.booking.status || 'Init'
            break
          case 'seguro':
            return 'TravelAce'
            break
          default:
            return 'Detail'
            break
        }
      },
      set (tab) {
        if (tab == 'seguro' && !this.departure.insurance) {
          tab = null
        }
        this.$router.push({
          name: this.$route.name,
          params: { tab, id: this.$route.params.id }
        })
      }
    },
    departure () {
      return this.$store.state.departures.find(
        departure => departure.id == this.$route.params.id
      )
    }
  },

  methods: {
    close () {
      this.$router.push({ name: this.departure.preview ? 'previews' : 'departures' })
    }
  }
}
</script>
